// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AgressorFlagType } from '../../Utils/Enums/Constants';
import { Message } from './Message';
import { DirectQuoteMessage } from './DirectQuoteMessage';
import { HistoryType } from '../History/HistoryType';
export class DirectQuote3Message extends DirectQuoteMessage {
    constructor() {
        super(Message.CODE_QUOTE3);
        this.Exchange = null;
        this.Price = Number.NaN;
        this.Size = Number.NaN;
        this.OpenInterest = null;
        this.BuyerSource = null;
        this.SellerSource = null;
        this.BuyerSourceId = 0;
        this.SellerSourceId = 0;
        this.LastVenue = null;
        // оно же аггрессор флаг -1-роут не ставит, 0-бай, 1-селл
        this.LType = AgressorFlagType.NotSet;
        this.Type = HistoryType.QUOTE_TRADES;
    }
}
